var map = {
	"./armpit.mp3": 7148,
	"./attic.mp3": 4484,
	"./banana.mp3": 7423,
	"./bog.mp3": 2506,
	"./bogey.mp3": 5197,
	"./boob.mp3": 8832,
	"./boring.mp3": 6850,
	"./bulging.mp3": 5021,
	"./bunion.mp3": 6544,
	"./burp.mp3": 7612,
	"./bushy.mp3": 9961,
	"./butt.mp3": 1434,
	"./buttock.mp3": 2752,
	"./cave.mp3": 6919,
	"./cellar.mp3": 6211,
	"./cheese.mp3": 1587,
	"./cheesy.mp3": 7711,
	"./chimney.mp3": 2146,
	"./cist.mp3": 8658,
	"./clod.mp3": 1871,
	"./cucumber.mp3": 8348,
	"./desert.mp3": 914,
	"./disgusting.mp3": 4471,
	"./dribble.mp3": 1580,
	"./drip.mp3": 2187,
	"./dripping.mp3": 2548,
	"./dungeon.mp3": 2048,
	"./faded.mp3": 8412,
	"./fart.mp3": 5336,
	"./field.mp3": 7799,
	"./flump.mp3": 5754,
	"./forest.mp3": 8422,
	"./fridge.mp3": 87,
	"./fudge.mp3": 672,
	"./furry.mp3": 9678,
	"./garbage.mp3": 5674,
	"./gassy.mp3": 1843,
	"./gelatinous.mp3": 607,
	"./greasy.mp3": 2218,
	"./gutter.mp3": 5579,
	"./hairy.mp3": 4645,
	"./hedge.mp3": 3942,
	"./hobbit.mp3": 7452,
	"./hole.mp3": 5990,
	"./itching.mp3": 1782,
	"./lake.mp3": 2176,
	"./log.mp3": 9198,
	"./lump.mp3": 5801,
	"./marsh.mp3": 1934,
	"./mould.mp3": 4665,
	"./mouldy.mp3": 2767,
	"./mud.mp3": 6029,
	"./muddy.mp3": 9967,
	"./nostril.mp3": 2605,
	"./nugget.mp3": 8143,
	"./ocean.mp3": 2068,
	"./oily.mp3": 7752,
	"./oozing.mp3": 8576,
	"./orange.mp3": 3133,
	"./orifice.mp3": 2140,
	"./pant.mp3": 5610,
	"./plop.mp3": 6376,
	"./plug.mp3": 4305,
	"./rancid.mp3": 2275,
	"./raspberry.mp3": 6887,
	"./river.mp3": 963,
	"./rotten.mp3": 1535,
	"./scab.mp3": 9959,
	"./scabby.mp3": 7829,
	"./scaly.mp3": 7678,
	"./scratching.mp3": 8161,
	"./sea.mp3": 7021,
	"./sewer.mp3": 8922,
	"./slime.mp3": 8664,
	"./slimy.mp3": 9396,
	"./slug.mp3": 9940,
	"./smell.mp3": 3379,
	"./smelly.mp3": 5912,
	"./soggy.mp3": 7832,
	"./space.mp3": 4618,
	"./spillage.mp3": 6894,
	"./spiny.mp3": 8305,
	"./spotty.mp3": 6123,
	"./squeaky.mp3": 3546,
	"./squelchy.mp3": 7241,
	"./squishy.mp3": 5217,
	"./stain.mp3": 7903,
	"./stench.mp3": 8456,
	"./stink.mp3": 5497,
	"./stinky.mp3": 6605,
	"./suburban.mp3": 3310,
	"./toad.mp3": 7003,
	"./toe.mp3": 8643,
	"./toenail.mp3": 4720,
	"./toilet.mp3": 9306,
	"./tree.mp3": 6317,
	"./trumpet.mp3": 4599,
	"./turd.mp3": 437,
	"./tussock.mp3": 4707,
	"./twit.mp3": 4554,
	"./urban.mp3": 2775,
	"./wandering.mp3": 9722,
	"./wart.mp3": 3289,
	"./waxy.mp3": 1395,
	"./wiener.mp3": 3774,
	"./wood.mp3": 8464,
	"./worm.mp3": 3196,
	"./yourea.mp3": 1665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4198;